import React from "react";
import { Box } from "@mui/material";
import founders from "../../../assets/landing/founders.png";
import { colors } from "../../../utils/constants";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { landingTokens } from "../theme";

interface FoundersProps {
  isMobile: boolean;
}

function Founders({ isMobile }: FoundersProps) {
  const styles = {
    foundersContainer: {
      justifyContent: "center",
      alignItems: "center",
      display: "flex",
      flexDirection: "column" as const,
      gap: 6,
      textAlign: "center" as const,
      background: landingTokens.gradient,
      padding: isMobile ? 4 : 12,
    },
    foundersTitle: {
      fontSize: isMobile ? 22 : 32,
      fontWeight: 600,
      color: colors.white,
      display: "flex",
      alignItems: "center",
      gap: "12px",
    },
    foundersDescription: {
      textAlign: "center" as const,
      color: colors.white,
      width: isMobile ? "100%" : "50%",
      fontSize: 16,
    },
    foundersImageContainer: {
      width: "100%",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column" as const,
      display: "flex",
      marginTop: isMobile ? 0 : 4,
      backgroundColor: "transparent",
      padding: 0,
    },
    foundersImageWrap: {
      position: "relative" as const,
      width: isMobile ? "70%" : "28%",
      minWidth: 180,
      maxWidth: 420,
    },
    foundersImage: {
      width: "100%",
      display: "block",
      filter: "grayscale(1) contrast(1.1) brightness(1.08)",
    },
    foundersNames: {
      fontSize: 20,
      fontWeight: 700,
      color: colors.white,
      marginTop: 16,
    },
    foundersTitleDescription: {
      fontSize: 16,
      fontWeight: 400,
      color: "rgba(255,255,255,0.85)",
    },
  };

  return (
    <Box sx={styles.foundersContainer}>
      <Box component="span" sx={styles.foundersTitle}>
        <CheckCircleIcon /> Fundadores
      </Box>

      <span style={styles.foundersDescription}>
        Estamos muito felizes com a validação do produto e esperamos que possa ajudar seu evento a
        gerar certificados de forma muito mais segura, fácil e justa para todos os participantes.
      </span>
      <span style={styles.foundersDescription}>
        Venha falar com a gente, e em poucos minutos criamos seu evento!
      </span>

      <Box sx={styles.foundersImageContainer}>
        <Box sx={styles.foundersImageWrap}>
          <img src={founders} style={styles.foundersImage} alt="Founders" />
        </Box>
        <span style={styles.foundersNames}>Hebert Soares e Eduardo Finotti</span>
        <span style={styles.foundersTitleDescription}>Fundadores da Qazando Cursos</span>
      </Box>
    </Box>
  );
}

export default Founders;
